export default __webpack_public_path__ + "static/media/logo.451a8de3.webp";